module.exports = {"data":{"site":{"siteMetadata":{"siteName":"Healthful&Inspired","siteUrl":"https://healthfulinspired.com","siteDescription":"Actively sharing the most useful health content for health, wellness, fitness, weight loss, fat burn & diets for people who want to become healthier. Subscribe!"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/seated-cable-rows"},"frontmatter":{"title":"Seated Cable Rows","date":null}}}]}},"pathContext":{"tag":"seated-cable-rows"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-seated-cable-rows.json
// module id = 3668
// module chunks = 218297198804973